import { z } from "zod";
import { emailSchema } from "../../../schemas/email";

const PhoneNumber = z.string().regex(/^\+\d{6,15}$/, "Phone number must be in international format, e.g. +61123456789");

export const emailContactSchema = z.object({
  email: emailSchema,
});

export const smsContactSchema = z.object({
  name: z.string().min(1, "Contact name is required").max(100, "Name must be less than 100 characters"),
  phone_number: PhoneNumber,
});

export type EmailContactFormData = z.infer<typeof emailContactSchema>;
export type SmsContactFormData = z.infer<typeof smsContactSchema>;
